import React, { Component } from 'react';
import { Card, Badge, ListGroup } from 'react-bootstrap';

import * as util from '../../library/utilitys';
class DashboardListGroup extends Component {
    render() {
        const { title = 'List Group', icon = '', listData = [], bg='primary' } = this.props;

        return (
            <Card className="card-border mb-0 h-100">
                <Card.Header className={`card-header-action bg-${bg}`}>
                    <h6 className="text-white">{icon && <i className={`${icon} me-2`}></i>}{title}</h6>
                </Card.Header>
                <Card.Body className="nicescroll-bar h-150p">
                    <div style={{ minHeight: '300px' }}>
                        <ListGroup variant="flush">
                            {listData.map((item, index) => (
                                <ListGroup.Item
                                    key={index}
                                    className="d-flex justify-content-between align-items-center"
                                >
                                    {item.name}
                                    <Badge bg="primary" pill>
                                        {util.formatNumber(item.rows, true)}
                                    </Badge>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </div>
                </Card.Body>
            </Card>
        );
    }
}

export default DashboardListGroup;
